import React from "react";
import "./FlexDCOSEND.css";
import PageHeader from "../../../components/headers/PageHeader";
import wave from "../../../assets/Images/waves/wave_mou.png";

export default function FlexDCOSEND() {
    return (
        <div className="flexdco-page">
            <PageHeader
                mediaSrc={wave}
                mediaType="image"
                subtitle="SEND Data Capture"
                title="Flexible Data Capture Options for SEND Compliance"
            />

            <section className="flexdco-section flexdco-introSection">
                <h2>Multiple Source Pathways for SEND-Ready Data</h2>
                    <p>
                    We support multiple data acquisition pathways to facilitate
                    efficient and accurate generation of SEND-compliant datasets,
                    regardless of the study conduct environment or source systems
                    used by the laboratory.
                </p>
            </section>

            <section className="flexdco-section flexdco-contentSection">
                <div className="flexdco-contentBlock">
                    <h2>LIMS Integration</h2>
                    <p>
                        Data can be directly extracted from Laboratory Information
                        Management Systems — LIMS, enabling automated transfer of
                        study data, minimizing manual intervention, improving
                        traceability, and ensuring consistency across SEND domains.
                    </p>
                </div>

                <div className="flexdco-contentBlock">
                    <h2>Raw Study Data Files</h2>
                    <p>
                        We can ingest and process electronic raw data from various
                        formats, including SAS datasets, Excel files, CSV files,
                        text files, instrument outputs, and proprietary laboratory
                        exports. Our team performs data mapping, transformation,
                        and quality review to ensure SEND compliance.
                    </p>
                </div>

                <div className="flexdco-contentBlock">
                    <h2>Study Reports and Supporting Files</h2>
                    <p>
                        For legacy studies or studies with limited electronic data
                        availability, data can be captured from study reports,
                        report appendices, data listings, pathology tables, and
                        other supporting study documentation. This approach enables
                        SEND conversion even when structured source datasets are
                        unavailable.
                    </p>
                    <p>
                        Our flexible data capture framework allows sponsors and CROs
                        to leverage existing data sources while ensuring efficient
                        preparation of high-quality SEND packages ready for
                        regulatory submission.
                    </p>
                </div>
            </section>
        </div>
    );
}